<template>
  <div class="content-contrainer">
    <div class="content-banner" :class="__lang"></div>
    <div class="content-menu-list">
      <div class="main-box">
        <router-link
          v-for="(item, index) in childrenMenu.child"
          :key="index"
          :to="item.link"
          class="content-menu-list-item"
          active-class="active"
        >{{item.name}}</router-link>
      </div>
    </div>
    <html404 v-if="content===null"></html404>
    <div v-else>
      <block :title="lang[__lang][routeName]">
        <div v-if="routeName=='salon'" class="main-box" style="margin-top: 50px;">
          <template v-if="__lang=='en'">
            <div
              class="menulink"
              v-for="(item, index) in content.list"
              :key="index"
              :to="routeName+'/content/'+item.id"
              style="text-decoration: none;"
              :style="index?'margin-top:50px;padding-top:60px;border-top:1px solid #ccc;':''"
            >
              <el-row>
                <el-col :span="14">
                  <h2 style="margin: 10px 0 30px 0;">{{item.title}}</h2>
                  <p style="margin-top: 15px;padding-right:15px;color: #333;" v-html="item.desc"></p>
                </el-col>
                <el-col :span="10">
                  <img width="486" height="364" :src="item.thumb" alt style="margin-left:14px">
                </el-col>
              </el-row>
            </div>
          </template>
          <template v-else>
            <el-row v-if="content.list&&content.list.length>0" :gutter="76">
              <el-col
                v-for="(item, index) in content.list"
                :key="index"
                :span="24"
                style="margin-bottom: 40px;"
              >
                <router-link
                  :to="item.id?(routeName+'/content/'+item.id):''"
                  style="text-decoration: none;"
                >
                  <el-card
                    class="new-card1"
                    style="background-color: #eee;"
                    shadow="hover"
                    :body-style="{ padding: '0px' }"
                  >
                    <img :src="item.thumb" style="height: 310px;width: 100%;">
                    <el-row :gutter="40" style="margin-top: 40px;">
                      <el-col :span="21">
                        <div class="new-title">
                          <p style="font-size: 28px;padding-left: 40px;">{{item.title}}</p>
                        </div>
                      </el-col>
                      <el-col :span="3" style="padding-left:0">
                        <p class="text-right" style="padding-right: 40px;">{{item.datetime}}</p>
                        <p class="text-right icon-right" style="font-size: 32px;padding: 0 40px;">
                          <i class="el-icon-right"></i>
                        </p>
                      </el-col>
                    </el-row>
                    <!-- <div class="new-title" style="margin: 60px 30px;">
                  <p style="font-size: 32px;">{{item.title}}</p>
                  <p>{{item.datetime}}</p>
                    </div>-->
                  </el-card>
                </router-link>
              </el-col>
            </el-row>
          </template>
        </div>
        <div v-if="routeName=='forum'" class="main-box" style="margin-top: 50px;">
          <template v-if="__lang=='en'">
            <div
              v-for="(item, index) in content.list"
              class="menulink"
              :key="index"
              :to="routeName+'/content/'+item.id"
              style="text-decoration: none;"
              :style="index?'margin-top:50px;padding-top:60px;border-top:1px solid #ccc;':''"
            >
              <el-row>
                <el-col :span="14">
                  <h2 style="margin: 10px 0 30px 0;">{{item.title}}</h2>
                  <p style="margin-top: 15px;padding-right:15px;color: #333;" v-html="item.desc"></p>
                </el-col>
                <el-col :span="10">
                  <img width="486" height="364" :src="item.thumb" alt style="margin-left:14px">
                </el-col>
              </el-row>
            </div>
          </template>
          <template v-else>
            <el-row v-if="content.list&&content.list.length>0" :gutter="76">
              <el-col
                v-for="(item, index) in content.list"
                :key="index"
                :span="24"
                style="margin-bottom: 40px;"
              >
                <router-link :to="routeName+'/content/'+item.id" style="text-decoration: none;">
                  <el-card
                    class="new-card1"
                    style="background-color: #eee;"
                    shadow="hover"
                    :body-style="{ padding: '0px' }"
                  >
                    <img :src="item.thumb" style="height: 310px;width: 100%;">
                    <el-row :gutter="40" style="margin-top: 40px;">
                      <el-col :span="21">
                        <div class="new-title">
                          <p style="font-size: 28px;padding-left: 40px;">{{item.title}}</p>
                        </div>
                      </el-col>
                      <el-col :span="3" style="padding-left:0">
                        <p class="text-right" style="padding-right: 40px;">{{item.datetime}}</p>
                        <p class="text-right icon-right" style="font-size: 32px;padding: 0 40px;">
                          <i class="el-icon-right"></i>
                        </p>
                      </el-col>
                    </el-row>
                  </el-card>
                </router-link>
              </el-col>
            </el-row>
          </template>
        </div>
        <div v-if="routeName=='communication'" class="main-box" style="margin-top: 50px;">
          <template v-if="__lang=='en'">
            <div
              class="menulink"
              v-for="(item, index) in content.list"
              :key="index"
              :to="routeName+'/content/'+item.id"
              style="text-decoration: none;"
            >
              <el-row>
                <el-col :span="14">
                  <h2 style="margin: 10px 0 30px 0;">{{item.title}}</h2>
                  <p style="margin-top: 15px;padding-right:15px;color: #333;" v-html="item.desc"></p>
                </el-col>
                <el-col :span="10">
                  <img width="486" height="364" :src="item.thumb" alt style="margin-left:14px">
                </el-col>
              </el-row>
            </div>
          </template>
          <template v-else>
            <router-link
              class="menulink"
              v-for="(item, index) in content.list"
              :key="index"
              :to="routeName+'/content/'+item.id"
              style="text-decoration: none;"
            >
              <el-row v-if="index===0">
                <el-col :span="13">
                  <img width="593" height="371" :src="item.thumb" alt>
                </el-col>
                <el-col :span="11">
                  <h2 style="margin-top: 120px;">{{item.title}}</h2>
                  <p style="margin-top: 20px; color: #333;">{{item.desc}}</p>
                  <p style="margin-top: 60px;">
                    {{item.datetime}}
                    <span class="pull-right">MORE +</span>
                  </p>
                </el-col>
              </el-row>
              <el-row
                v-else
                style="margin-top: 20px; border-top: 1px solid #ccc; padding-top: 20px;"
              >
                <el-col :span="8">
                  <img width="321" height="214" :src="item.thumb" alt>
                </el-col>
                <el-col :span="16">
                  <h2 style="margin-top: 40px;">{{item.title}}</h2>
                  <p style="margin-top: 20px; color: #333;">{{item.desc}}</p>
                  <p style="margin-top: 30px;">
                    {{item.datetime}}
                    <span class="pull-right">MORE +</span>
                  </p>
                </el-col>
              </el-row>
            </router-link>
          </template>
        </div>
      </block>
    </div>
  </div>
</template>

<script>
import { navbar, news as data } from "../../data.js";
import lang from "../../lang.js";
import block from "../../components/block.vue";
import html404 from "../../components/404.vue";
import { setTimeout } from 'timers';
export default {
  name: "news",
  components: {
    block,
    html404
  },
  data() {
    return {
      lang,
      data,
      active: 0
    };
  },
  computed: {
    menus() {
      return navbar({
        lang: this.$route.params.lang || "zh-CN"
      });
    },
    childrenMenu() {
      return this.menus.find(v => v.id == "news");
    },
    __lang() {
      return this.$route.params.lang;
    },
    content() {
      const lang = this.__lang;
      const name = this.$route.name;
      console.log(data[lang][name], lang, name);
      return data[lang][name] || null;
    },
    routeName() {
      return this.$route.name;
    }
  },
  methods: {
    checkLabor(index) {
      this.active = index;
    }
  },
  updated(){
    if(this.__lang=='en' && this.$route.params.id){
      let num = this.content.list.length - this.$route.params.id;
      document.documentElement.scrollTop = 400 + (429 * num);
    }
  },
  mounted(){
    if(this.__lang=='en' && this.$route.params.id){
      let num = this.content.list.length - this.$route.params.id;
      setTimeout(()=>{
        document.documentElement.scrollTop = 400 + (429 * num);
      },200);
    }
  }
};
</script>

<style lang="less" scoped>
.content-contrainer {
  padding-bottom: 60px;
}
.content-banner {
  margin-top: 70px;
  width: 100%;
  height: 340px;
  background: url(../../assets/img/banner_news.jpg) center center no-repeat;
  &.en {
    background: url(../../assets/img/banner_news_en.png) center center no-repeat;
  }
}
.content-menu-list {
  border-bottom: 1px solid #999;
  overflow: hidden;
  .content-menu-list-item {
    text-decoration: none;
    color: #222;
    float: left;
    line-height: 60px;
    font-size: 16px;
    padding: 0 20px;
    &.active {
      color: #d22c1d;
    }
    &.active:after {
      display: block;
      content: " ";
      width: 60%;
      height: 4px;
      background-color: #d22c1d;
      margin: auto;
    }
  }
}
.filed-desc {
  padding: 40px 0;
  line-height: 30px;
  font-size: 18px;
}
.labor-checkbox {
  margin-bottom: 40px;
  .labor-checkbox-btn {
    display: block;
    width: 100%;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding: 0;
    background-color: #eee;
    color: #222;
    text-decoration: none;
    border-radius: 0;
    font-size: 18px;
    .icon {
      width: 36px;
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      margin-right: 10px;
    }
    .icon1 {
      display: none;
    }
    .icon2 {
      display: inline-block;
    }
    &.active {
      color: #fff;
      background-color: #d22c1d;
      .icon2 {
        display: none;
      }
      .icon1 {
        display: inline-block;
      }
    }
  }
}
.st-desc {
  position: relative;
  .text1-box {
    position: absolute;
    top: 0;
    left: 130px;
    right: 143px;
    margin: 100px auto;
    height: 130px;
    .icon {
      margin-top: 20px;
      margin-left: 100px;
      margin-right: 50px;
      float: left;
    }
    p {
      color: #fff;
      margin-top: 20px;
      margin-right: 50px;
      line-height: 1.8;
    }
  }
}
.databox {
  margin-top: 20px;
}
.datacontent {
  img {
    width: 100%;
  }
}
.new-card {
  img {
    transition: 0.6s;
  }
  &:hover {
    text-decoration: underline;
    background-color: #fff !important;
    img {
      transform: scale(1.1);
    }
  }
}
.new-card1 {
  .icon-right {
    transition: 0.6s;
  }
  &:hover {
    text-decoration: underline;
    background-color: #fff !important;
    .icon-right {
      color: #d22c1d;
      transform: translateX(20px);
    }
  }
}
</style>
